import { adminApi } from './api';

export async function ensureRecentAdminReauth() {
  const password = window.prompt('This is a high-risk action. Enter your admin password to continue.');
  if (password === null) {
    return false;
  }
  const mfaCode = window.prompt('Enter your MFA code if enabled. Leave blank if MFA is not enabled.');
  await adminApi.reauthenticateAdmin({
    password,
    mfa_code: (mfaCode || '').trim() || undefined,
  });
  return true;
}
